import React, { Suspense, useState } from "react";
import { Box, LinearProgress } from "@mui/material";
import NavBar from "./NavBar";
import TopBar from "./TopBar";
import { Outlet } from "react-router-dom";
import { useTheme } from "@emotion/react";

function Main() {
  const theme = useTheme();
  const [openNavBarMobile, setOpenNavBarMobile] = useState(false);
  const today = () => {
    const date = new Date();
    const day = ("0" + date.getDate()).slice(-2);
    const month = ("0" + (date.getMonth() + 1)).slice(-2);
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  };

  return (
    <Box
      component="div"
      sx={{
        minHeight: "100vh",
        display: "flex",
        "@media all and (-ms-high-contrast:none)": {
          height: 0, // IE11 fix
        },
      }}
    >
      <NavBar
        onMobileClose={() => setOpenNavBarMobile(false)}
        openMobile={openNavBarMobile}
        today={today()}
      />
      <TopBar onOpenNavBarMobile={() => setOpenNavBarMobile(true)} />
      <Box
        component="div"
        sx={{
          paddingTop: 8,
          flexGrow: 1,
          maxWidth: "100%",
          overflowX: "hidden",
          [theme.breakpoints.up("lg")]: {
            paddingLeft: 28,
          },
          [theme.breakpoints.down("xs")]: {
            paddingTop: 6,
          },
        }}
      >
        <Suspense fallback={<LinearProgress />}>
          <Outlet />
        </Suspense>
      </Box>
    </Box>
  );
}

export default Main;
